import { Monitor, RefreshCcw, ShieldCheck, Smartphone } from "lucide-react";

export const SERVICES_DETAIL = [
  {
    n: "01",
    icon: Monitor,
    title: "Website Design",
    text: "A complete website for businesses starting from zero — designed around your brand and built to make an impression from day one.",
    price: null,
    process: ["Discovery call", "Direction", "Design", "Feedback", "Launch"],
    included: [
      "Fully custom design around your brand",
      "Mobile-first layouts",
      "Copy and content guidance",
      "Two rounds of design revisions",
      "Hosting and domain setup handled",
    ],
    who: "New businesses — or established ones finally getting the website they've needed.",
  },
  {
    n: "02",
    icon: RefreshCcw,
    title: "Website Refresh",
    text: "A brand-new website for businesses whose current one feels dated — completely redesigned and rebuilt from scratch, not patched up.",
    price: null,
    process: ["Discovery call", "Redesign", "Rebuild", "Relaunch"],
    included: [
      "A completely new website, designed around your brand",
      "Your existing content migrated and improved",
      "Fast, modern build with hosting set up for you",
      "Basic SEO setup",
      "Relaunch handled end-to-end",
    ],
    who: "Established businesses whose website no longer reflects how good they are.",
  },
  {
    n: "03",
    icon: Smartphone,
    title: "Seamless on Mobile",
    text: "Every website we design works beautifully across phones, tablets and desktops — because that's where your customers are.",
    price: null,
    process: ["Design", "Mobile refinement", "Testing", "Polish"],
    included: [
      "Designs created mobile-first, never shrunk after",
      "Touch-friendly navigation and buttons",
      "Testing across devices and screen sizes",
      "Fast loading on mobile connections",
    ],
    who: "Any business whose customers browse on their phone — which is most of them.",
  },
  {
    n: "04",
    icon: ShieldCheck,
    title: "Care & Management",
    text: "After launch, we keep your website updated, secure and improving — so it never goes out of date again.",
    price: null,
    process: ["Launch", "Regular check-ins", "Updates", "Ongoing improvements"],
    included: [
      "Content updates whenever you need them",
      "Hosting, security and backups handled",
      "Performance monitoring",
      "Priority support, direct from us",
    ],
    who: "Businesses that want their website looked after without ever thinking about it.",
  },
];
